import { first, sum } from 'lodash';

export interface IShufflePitch {
  _id: string;
  frequency: number;
}

export class QueueHelper {
  // converts frequencies like 1, 2, 3... into (1)/total, (1+2)/total, (1+2+3)/total...
  static convertToCumulative(pitches: IShufflePitch[]): IShufflePitch[] {
    const total = sum(pitches.map((p) => Math.abs(p.frequency)));

    if (total === 0) {
      return [];
    }

    let cumulative = 0;

    // replace frequency w/ cumulative
    const output: IShufflePitch[] = [];

    for (const p of pitches) {
      cumulative += Math.abs(p.frequency / total);

      output.push({
        _id: p._id,
        frequency: cumulative,
      });
    }

    return output;
  }

  // naive approach
  static getShufflePitchID(pitches: IShufflePitch[]): string | undefined {
    if (pitches.length === 0) {
      return;
    }

    const cPitches = this.convertToCumulative(pitches);

    if (cPitches.length === 0) {
      return;
    }

    const rand = Math.random();

    const randPitch = cPitches.find((p) => p.frequency > rand);

    if (randPitch) {
      return randPitch._id;
    }

    return first(pitches)?._id;
  }
}
